module.exports = __webpack_public_path__ + "img/iconjl.c7c4ee25.png";